import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Feedback } from '@shared/models/feedback';

import { ApiService } from './api.service';

@Injectable()
export class FeedbackService extends ApiService<Feedback> {
  constructor(http: HttpClient) {
    super(http);
    this.url = 'recruiters-feedback/';
  }

  getForJob(jobId: number): Observable<Feedback[]> {
    return this.get({ url: 'job/' + jobId });
  }
}
